// 云销退还、云采充值共用直接导出逻辑，不弹出补填表单。
export default {
  // 保存当前导出状态，防止重复点击。
  data() {
    return {
      paymentExporting: false // 付款申请单正在下载。
    }
  },
  methods: {
    // 仅发送订单主键，未维护字段由后端在 PDF 中留空。
    async exportPaymentApplication(row, purchase) {
      const typeLabel = row.depositType === '1' ? '付款' : '退款'
      if (this.paymentExporting) return
      this.paymentExporting = true
      try {
        const api = purchase ? this.$apis.yxcBondRecord : this.$apis.bondRecord
        const response = await this.$axios.post(api.exportPaymentApplicationPdf, {
          depositId: row.depositId // 已创建的资金订单主键。
        }, { responseType: 'blob' })
        if (!response.data || !response.data.type.includes('pdf')) throw new Error('服务器未返回有效的 PDF 文件')
        // 创建临时下载链接，并在触发下载后释放。
        const url = URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url
        link.download = typeLabel + '申请单-' + row.depositId + '.pdf'
        document.body.appendChild(link)
        link.click()
        link.remove()
        setTimeout(() => URL.revokeObjectURL(url), 1000)
      } catch (error) {
        this.$message.error(error.message || typeLabel + '申请单导出失败')
      } finally {
        this.paymentExporting = false
      }
    }
  }
}
